export const _SUPPORT = {
    CREATE_NEW_TICKET_REQUEST : 'CREATE_NEW_TICKET_REQUEST',
    CREATE_NEW_TICKET_SUCCESS : 'CREATE_NEW_TICKET_SUCCESS',
    CREATE_NEW_TICKET_FAILURE : 'CREATE_NEW_TICKET_FAILURE',

    FETCH_TICKETS_REQUEST : 'FETCH_TICKETS_REQUEST',
    FETCH_TICKETS_SUCCESS : 'FETCH_TICKETS_SUCCESS',
    FETCH_TICKETS_FAILURE : 'FETCH_TICKETS_FAILURE',

    DELETE_TICKET_REQUEST : 'DELETE_TICKET_REQUEST',
    DELETE_TICKET_SUCCESS : 'DELETE_TICKET_SUCCESS',
    DELETE_TICKET_FAILURE : 'DELETE_TICKET_FAILURE',

    SEND_MESSAGE_REQUEST : 'SEND_MESSAGE_REQUEST',
    SEND_MESSAGE_SUCCESS : 'SEND_MESSAGE_SUCCESS',
    SEND_MESSAGE_FAILURE : 'SEND_MESSAGE_FAILURE',
    
    FETCH_MESSAGES_REQUEST : 'FETCH_MESSAGES_REQUEST',
    FETCH_MESSAGES_SUCCESS : 'FETCH_MESSAGES_SUCCESS',
    FETCH_MESSAGES_FAILURE : 'FETCH_MESSAGES_FAILURE' 

}